import React, { useEffect, useRef, useState } from 'react';
import { FaEthereum, FaClock, FaStar } from "react-icons/fa";
import { Container, Row, Col, Card, Button, Dropdown } from "react-bootstrap";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import arrowup1 from '../../Assets/Image/arrow-chart (2).png';
import arrowup from '../../Assets/Image/arrow-chart (1).png';
import arrodown1 from '../../Assets/Image/chart-down (2).png'
import graphi from '../../Assets/Image/graphi.png';
import moneyImg from '../../Assets/Image/money-bag.png';
import salary from '../../Assets/Image/salary.png';
import money1 from '../../Assets/Image/profit.png';
import money2 from '../../Assets/Image/piggy-bank.png';
import money3 from '../../Assets/Image/budget.png';
import money4 from '../../Assets/Image/pay.png';
import Chart from "chart.js/auto";
import Marquee from "react-fast-marquee";
import profit3 from '../../Assets/Image/profit3.png';
import profit4 from '../../Assets/Image/profit4.png';
import profit5 from '../../Assets/Image/profit5.png';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import income from '../../Assets/Image/income.png';
import usd from '../../Assets/Image/usd.png';
import wallet from '../../Assets/Image/wallet.png';
import hour24 from '../../Assets/Image/hour24.png';
import { api_url, titleDescription, website } from '../../config/Config';
import Table from 'react-bootstrap/Table';
import _fetch from '../../config/api';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import scan_code from '../../Assets/Image/scan_code.png';
import 'react-responsive-modal/styles.css';
import toasted from '../../config/toast';
import Modal from 'react-responsive-modal';
import light_banner1 from '../../Assets/Image/light_banner1.png';
import dateformat from "dateformat";
import { ColorRing } from 'react-loader-spinner';
import { VolumeUpRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import CandleChart from './CandleChart ';
import mt5 from '../../Assets/Image/mt5.jpeg';
import bot from '../../Assets/Image/bot.png';
import mlm from '../../Assets/Image/multi-level-marketing (1).png';
import birefcase from '../../Assets/Image/briefcase.png';
import tradeVideo from '../../Assets/Image/tradeVideo.mp4';
import ReactPaginate from 'react-paginate';

const Dashboard = (props) => {

  var myVariable = Date.now();
  var makeDate = new Date(myVariable);
  var prev = new Date(makeDate.getFullYear(), makeDate.getMonth() - 1);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = `${props.pageTitle} | ${titleDescription}`;
  });

  const [sponsorId, setSponsorId] = useState('');
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [loading, setLoading] = useState(true);
  const [fundValues, setFundValues] = useState([]);
  const [totalRecords, setTotalRecords] = useState([]);
  const [bannerData, setBannerData] = useState({ banner_status: "", description: "", banner: "" });
  const [newsData, setNewsData] = useState({ title: "", description: "", status: "" });
  const [tradeData, setTradeData] = useState([]);
  const [tradeActivation, setTradeActivation] = useState({ updated_at: '' });
  const [allUserData, setAllUserData] = useState({ boosterIncome: 0, totalIncome2: '', totalIncome: "", avaliableIncome: "", TotalDeposit: "", AvaliableDeposit: { fundValue: "", reBuyValue: "" }, directIncome: "", levelIncome: "", poolIncome: "", roiIncome: "", royaltyIncome: "", userInfo: { user_info: { ib_rank: 0, rank: 0, name: "", income_limit: "", package: { current_package: "", previous_package: "", total_package: "" } } } });
  const [allMt5UserData, setAllMT5UserData] = useState({});
  const [allSalaryAcheived, setAllSalaryAcheived] = useState(0);
  const [bussinessData, setBussinessData] = useState({ firstleg: 0, secondleg: 0, thirdleg: 0 });
  const [userRank, setUserRank] = useState({ rank: 0, rank_name: "" });
  const [tradefund, settradefund] = useState({ total_income: 0, bot_total_income: 0, deposit_fund: 0, trade_fund: 0, compound_trade_fund: 0, salary_income: 0, mt5_profit: 0, available_income: 0, bot_available_income: 0 });
  const [userinfo, setuserinfo] = useState({});
  const [active, setActive] = useState('Inactive');
  const [activateDate, setActivateDate] = useState(null);
  const [price, setPrice] = useState("Loading...");
  const [priceChange, setPriceChange] = useState(null);
  const [page, setpage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyCount, setKeycount] = useState(0);
  const [liveprices, setLivePrices] = useState([]);
  const [rankArray, setRankArray] = useState([

    { "business": 2000, "total_business": 2000, "rank_name": "Jade", "rank_level": 1, "amount": 0 },
    { "business": 5000, "total_business": 7000, "rank_name": "Peral", "rank_level": 2, "amount": 200 },
    { "business": 10000, "total_business": 17000, "rank_name": "Sapphire", "rank_level": 3, "amount": 400 },
    { "business": 25000, "total_business": 42000, "rank_name": "Sapphire 25", "rank_level": 4, "amount": 1000 },
    { "business": 50000, "total_business": 92000, "rank_name": "Ruby", "rank_level": 5, "amount": 2000 },
    { "business": 100000, "total_business": 192000, "rank_name": "Emerald", "rank_level": 6, "amount": 4000 },
    { "business": 250000, "total_business": 442000, "rank_name": "Diamond", "rank_level": 7, "amount": 10000 },
    { "business": 500000, "total_business": 942000, "rank_name": "Double Diamond", "rank_level": 8, "amount": 20000 },
    { "business": 1000000, "total_business": 1942000, "rank_name": "Triple Diamond", "rank_level": 9, "amount": 40000 },
    { "business": 2000000, "total_business": 3942000, "rank_name": "Crown Diamond", "rank_level": 10, "amount": 80000 },
    { "business": 5000000, "total_business": 8942000, "rank_name": "Royal Crown Diamond", "rank_level": 11, "amount": 200000 },
    { "business": 10000000, "total_business": 18942000, "rank_name": "Vice President", "rank_level": 12, "amount": 400000 },
    { "business": 30000000, "total_business": 48942000, "rank_name": "Senior Vice President", "rank_level": 13, "amount": 1200000 },
    { "business": 50000000, "total_business": 98942000, "rank_name": "Global President", "rank_level": 14, "amount": 2000000 },
    { "business": 125000000, "total_business": 223942000, "rank_name": "Universal President", "rank_level": 15, "amount": 2500000 },
    { "business": 250000000, "total_business": 473942000, "rank_name": "Streakk President", "rank_level": 16, "amount": 3500000 },
  ]);

  const rankLevel = userRank?.rank;
  let PreviousMaxKingMaker = 0;
  let PreviousMaxSecondLeg = 0;
  let PreviousMaxOther = 0;

  if (rankLevel > 0) {
    const previousRank = rankLevel - 1;

    PreviousMaxKingMaker = (rankArray?.[previousRank]?.total_business) * 0.4;
    PreviousMaxSecondLeg = (rankArray?.[previousRank]?.total_business) * 0.4;
    PreviousMaxOther = (rankArray?.[previousRank]?.total_business) * 0.2;
  }

  let location = useLocation();
  // const navigate = useNavigate();

  const copyToClipboard = (address) => {
    var textField = document.createElement('textarea');
    textField.innerText = address;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    toasted.success('Address copied successfull!');
  }

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const data1 = await _fetch(`${api_url}user/userInfo/`, "GET", {});
    //     if (data1.status === "success" && data1?.data?.data) {
    //       // setSponsorId(data1?.data?.data?.username);
    //       setUserRank(data1?.data?.data?.user_info);
    //       settradefund(data1?.data?.data?.income_info);
    //       setuserinfo(data1?.data?.data);
    //       const useractive = String(data1?.data?.data?.active_status);
    //       setActive(useractive === "true" ? "Active" : "Inactive");
    //       setActivateDate(useractive === "true" ? data1?.data?.data?.user_info?.activate_date || "----" : null);
    //     } else {
    //       localStorage.clear();
    //       navigate("/login");
    //     }

    //     // await Promise.all([
    //     //   getUserData(),
    //     //   getmt5UserData(),
    //     //   getBannerData(),
    //     //   getNewsData(),
    //     // ]);
    //   } catch (error) {
    //     console.error("Error fetching user data:", error);
    //   }
    // };

    const fetchPrice = async () => {
      try {
        const lastFetch = localStorage.getItem("goldPriceTimestamp");
        const now = Date.now();

        if (!lastFetch || now - lastFetch > 5 * 60 * 1000) {
          const response = await fetch(
            `https://api.coingecko.com/api/v3/simple/price?ids=tether-gold&vs_currencies=usd`
          );
          const data = await response.json();
          const price = `$${data["tether-gold"]?.usd?.toFixed(2) || "N/A"}`;
          setPrice(price);
        } else {
          setPrice(localStorage.getItem("goldPrice") || "N/A");
        }
      } catch (error) {
        console.error("Error fetching gold price:", error);
        setPrice("Error");
      }
    };

    const fetchLivePrices = async () => {
      try {
        const response = await fetch("https://v6.exchangerate-api.com/v6/ce7ee80e0eabba28d6aff7b4/latest/USD");
        const data = await response.json();
        setLivePrices([
          { pair: "USD/EUR", rate: data.conversion_rates.EUR },
          { pair: "USD/GBP", rate: data.conversion_rates.GBP },
          { pair: "USD/JPY", rate: data.conversion_rates.JPY },
          { pair: "USD/AUD", rate: data.conversion_rates.AUD },
          { pair: "USD/CAD", rate: data.conversion_rates.CAD },
          { pair: "USD/CHF", rate: data.conversion_rates.CHF },
          { pair: "USD/NZD", rate: data.conversion_rates.NZD },
          { pair: "USD/SGD", rate: data.conversion_rates.SGD },
          { pair: "USD/HKD", rate: data.conversion_rates.HKD },
          { pair: "USD/CNY", rate: data.conversion_rates.CNY },
          { pair: "USD/INR", rate: data.conversion_rates.INR },
          { pair: "USD/KRW", rate: data.conversion_rates.KRW },
          { pair: "USD/BRL", rate: data.conversion_rates.BRL },
          { pair: "USD/ZAR", rate: data.conversion_rates.ZAR },
          { pair: "USD/MXN", rate: data.conversion_rates.MXN },
        ]);
      } catch (error) {
        console.error("Error fetching prices:", error);
      }
    };

    // fetchData();
    fetchPrice();
    fetchLivePrices();

    const interval = setInterval(fetchPrice, 60000);
    const livePriceInterval = setInterval(fetchLivePrices, 10 * 60 * 1000);

    return () => {
      clearInterval(interval);
      clearInterval(livePriceInterval);
    };
  }, [location.pathname]);

  const handlePageClick = async (event) => {
    const newOffset = (event.selected + 1);
    setpage(newOffset);
  };

  const [todayProfit, setTodayProfit] = useState(0);
  const [currentMonthProfit, setcurrentMonthProfit] = useState(0);

  const data1 = [
    ["Task", "Hours per Day"],
    ["XRP", 11],
    ["Bitcoin", 2],
    ["Cardano", 2],
    ["Etherium", 2],
  ];

  const [info, setInfo] = useState({ sponsor_id: "", business: { direct_business: '', team_business: '' } });
  const [teamBusiness, setTeamBusiness] = useState(0);
  const [userInfo, setUserInfo] = useState({ income_earn: 0, income_limit: 0 });
  const [balance, setBalance] = useState();
  // const [mt5Balance, setMt5Balance] = useState();
  const [currentPrice, setCurrentPrice] = useState('');
  const [legTeamData, setLegTeamData] = useState({ firstleg: 0, secondleg: 0 });
  const [isTawkLoaded, setIsTawkLoaded] = useState(false);
  const [messages, setMessages] = useState([{ sender: "bot", text: "Hello! How can I assist you today?", time: "Just now" }]);
  const [open3, setOpen3] = useState(false);

  const closeModal3 = () => {
    setOpen3(false);
  };

  useEffect(() => {
    document.title = `${props.pageTitle} | ${titleDescription}`;

    if (!isTawkLoaded) {
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_API.visitor = {
        name: 'Nexus', // Replace with dynamic user data if available
        email: 'Nexus@example.com'
      };

      const tawkScript = document.createElement("script");
      tawkScript.src = "https://embed.tawk.to/67fa294c0d9928190ebbc76c/default";
      tawkScript.async = true;
      tawkScript.charset = "UTF-8";
      tawkScript.setAttribute("crossorigin", "*");
      document.body.appendChild(tawkScript);
      setIsTawkLoaded(true);
    }

    getUserInfo();
    getBannerData();
    getNewsData();
    getTradeData();
    getBalance();
    getTeamLegBusiness();
    getUserData();
    getmt5UserData();
    getSalaryAcheivement()

    if (!chartRef.current) return;

    const ctx = chartRef.current.getContext("2d");

    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    chartInstanceRef.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            label: "EUR/USD",
            data: [],
            borderColor: "#4A90E2",
            backgroundColor: "rgba(74, 144, 226, 0.2)",
            borderWidth: 2,
            tension: 0.5, // Curve smoothing
            pointBackgroundColor: "#4A90E2",
            pointBorderColor: "#fff",
            pointRadius: 4,
            pointHoverRadius: 6,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            ticks: { color: "#ccc" },
            grid: { color: "rgba(255, 255, 255, 0.1)" },
          },
          y: {
            beginAtZero: false,
            ticks: { color: "#ccc" },
            grid: { color: "rgba(255, 255, 255, 0.1)" },
          },
        },
        plugins: {
          legend: {
            labels: { color: "#ccc", boxWidth: 20 },
          },
          tooltip: {
            enabled: true,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            titleColor: "#fff",
            bodyColor: "#ddd",
            borderColor: "#4A90E2",
            borderWidth: 1,
            displayColors: false,
          },
        },
      },
    });

    fetchLiveData();
    const interval = setInterval(fetchLiveData, 3000);

    return () => {
      clearInterval(interval);
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [isTawkLoaded]);

  useEffect(() => {
    getfundData();
  }, [page, limit]);

  const getUserInfo = async () => {
    let res = await _fetch(`${api_url}user/userInfo/`, "GET", {});
    let teamBusinessResponse = await _fetch(`${api_url}report/team-business`, "GET", {});

    if (res?.status === 'success') {
      setInfo(res?.data?.data);
      setSponsorId(res?.data?.data?.username);
      setUserInfo(res?.data?.data?.user_info);
      setUserRank(res?.data?.data?.user_info);
      settradefund(res?.data?.data?.income_info);
      // setTeamBusiness(res?.data?.teamBusiness);
      const useractive = String(res?.data?.data?.active_status);
      setActive(useractive === "true" ? "Active" : "Inactive");
      setActivateDate(useractive === "true" ? res?.data?.data?.user_info?.activate_date || "----" : null);
    }

    if (teamBusinessResponse?.status === 'success') {
      setTeamBusiness(teamBusinessResponse?.data?.teamBusiness);
    }
  }

  const getBannerData = async () => {
    let res = await _fetch(`${api_url}profile/bannerdata`, "GET", {})
    if (res?.status === "success") {
      setOpen3(res?.data?.[0]?.user_banner?.banner_status);
      setBannerData(res?.data?.[0]?.user_banner);
    }
  }

  const getNewsData = async () => {
    let res = await _fetch(`${api_url}profile/newsData`, "GET", {})
    if (res?.status === "success") {
      setNewsData(res?.data);
    }
  }

  const getTradeData = async () => {
    let res = await _fetch(`${api_url}report/trade-detail`, "GET", {});
    let res2 = await _fetch(`${api_url}report/trade-activation`, "GET", {});
    // let res3 = await _fetch(`${api_url}report/trade-history`, "GET", {});

    if (res?.status === "success") {
      setTradeData(res?.data);
    }
    if (res2?.status === "success") {
      setTradeActivation(res2?.data);
    }
  }

  const getBalance = async () => {
    setLoading(true);
    const data = await _fetch(`${api_url}withdraw/check-trade-balance`, "GET", {}, {});

    if (data?.status === 'success') {
      setLoading(false);
      setBalance(data?.data);
    }
  }

  const getTeamLegBusiness = async () => {
    let res = await _fetch(`${api_url}report/legBusinessCalculate`, "GET", {});
    if (res?.status === "success") {
      setLegTeamData(res?.data);
    }
  }

  const getfundData = async () => {
    let data = await _fetch(`${api_url}fund/getfund?page=${page}&limit=${limit}`, "GET", {});
    if (data?.status === "success") {
      setFundValues(data?.data);
      setTotalRecords(data?.total);
    }
    if (page > 1) {
      setKeycount(0);
      var count = page - 1;
      setKeycount(count * limit);
    }
  }

  const getUserData = async () => {
    setLoading(true);
    let res = await _fetch(`${api_url}profile/dashboard`, "GET", {});

    if (res?.status === "success") {
      setAllUserData(res?.data);
      setBussinessData(res?.data?.business?.business);
      setTodayProfit(res?.data?.profitDetails?.todayProfit);
      setcurrentMonthProfit(res?.data?.profitDetails?.currentMonthProfit);
      setLoading(false);
    }
  }

  const getmt5UserData = async () => {
    setLoading(true);
    let res3 = await _fetch(`${api_url}tradeX/mt5-user`, "GET", {});

    if (res3?.status === "success") {
      setAllMT5UserData(res3.data)
      // console.log('duygyegygefteg', res3.data.tradeXCompoundEntry);

      setLoading(false);
    }
  }

  const getSalaryAcheivement = async () => {
    let salaryData = await _fetch(`${api_url}report/royality-summary`, "GET", {});
    if (salaryData?.status === "success") {
      setAllSalaryAcheived(salaryData?.totalAmount);
    }
  }

  const fetchLiveData = async () => {
    if (!chartInstanceRef.current) return;

    try {
      const response = await fetch(
        "https://api.twelvedata.com/time_series?symbol=EUR/USD&interval=1min&apikey=e824d1cd3ae04227ac97723d2660197b"
      );
      const data = await response.json();

      if (data.values) {
        const latest = data.values[0];
        const time = latest.datetime.split(" ")[1];
        const price = parseFloat(latest.close);
        const prevPrice = parseFloat(data.values[1]?.close || price);
        const priceDiff = ((price - prevPrice) / prevPrice) * 100;
        setCurrentPrice(price.toFixed(2));
        setPriceChange(priceDiff.toFixed(2));

        const chart = chartInstanceRef.current;
        chart.data.labels.push(time);
        chart.data.datasets[0].data.push(price);

        if (chart.data.labels.length > 20) {
          chart.data.labels.shift();
          chart.data.datasets[0].data.shift();
        }

        chart.update();
      }
    } catch (error) {
      console.error("Error fetching Forex data:", error);
    }
  };

  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  // useEffect(() => {
  //   if (!chartRef.current) return;

  //   const ctx = chartRef.current.getContext("2d");

  //   if (chartInstanceRef.current) {
  //     chartInstanceRef.current.destroy();
  //   }

  //   chartInstanceRef.current = new Chart(ctx, {
  //     type: "line",
  //     data: {
  //       labels: [],
  //       datasets: [
  //         {
  //           label: "EUR/USD",
  //           data: [],
  //           borderColor: "#4A90E2",
  //           backgroundColor: "rgba(74, 144, 226, 0.2)",
  //           borderWidth: 2,
  //           tension: 0.5, // Curve smoothing
  //           pointBackgroundColor: "#4A90E2",
  //           pointBorderColor: "#fff",
  //           pointRadius: 4,
  //           pointHoverRadius: 6,
  //           fill: true,
  //         },
  //       ],
  //     },
  //     options: {
  //       responsive: true,
  //       maintainAspectRatio: false,
  //       scales: {
  //         x: {
  //           ticks: { color: "#ccc" },
  //           grid: { color: "rgba(255, 255, 255, 0.1)" },
  //         },
  //         y: {
  //           beginAtZero: false,
  //           ticks: { color: "#ccc" },
  //           grid: { color: "rgba(255, 255, 255, 0.1)" },
  //         },
  //       },
  //       plugins: {
  //         legend: {
  //           labels: { color: "#ccc", boxWidth: 20 },
  //         },
  //         tooltip: {
  //           enabled: true,
  //           backgroundColor: "rgba(0, 0, 0, 0.7)",
  //           titleColor: "#fff",
  //           bodyColor: "#ddd",
  //           borderColor: "#4A90E2",
  //           borderWidth: 1,
  //           displayColors: false,
  //         },
  //       },
  //     },
  //   });

  //   fetchLiveData();
  //   const interval = setInterval(fetchLiveData, 3000);

  //   return () => {
  //     clearInterval(interval);
  //     if (chartInstanceRef.current) {
  //       chartInstanceRef.current.destroy();
  //     }
  //   };
  // }, []);

  // useEffect(() => {
  //   if (!isTawkLoaded) {
  //     window.Tawk_API = window.Tawk_API || {};
  //     window.Tawk_API.visitor = {
  //       name: 'Nexus', // Replace with dynamic user data if available
  //       email: 'Nexus@example.com'
  //     };

  //     const tawkScript = document.createElement("script");
  //     tawkScript.src = "https://embed.tawk.to/67fa294c0d9928190ebbc76c/default";
  //     tawkScript.async = true;
  //     tawkScript.charset = "UTF-8";
  //     tawkScript.setAttribute("crossorigin", "*");
  //     document.body.appendChild(tawkScript);

  //     setIsTawkLoaded(true);
  //   }
  // }, [isTawkLoaded]);

  return (
    <>
      <main>
        <div>
          <div className="marquee">
            <div className="marquee-content">
              <Marquee speed={70} >
                USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
                AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
                CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

                USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
                AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
                CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

                USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
                AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
                CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

                USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
                AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
                CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

                USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
                AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
                CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

                USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
                AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
                CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>
              </Marquee>
            </div>
          </div>

          <div className="coustom_container">
            <div className="main_inner_sec ">
              <div className='table_responsive'>
              </div>
              <div className="header-left">
                <div className="link-copy ">
                  <input type='text' value={`${website}register/${sponsorId}`} disabled></input>
                  <div className="icon-copy">
                    <FileCopyIcon onClick={() => { copyToClipboard(`${website}register/${sponsorId}`) }} />
                  </div>
                </div>
                <div className="icons_im">
                  <img src={scan_code} className="scan_code" alt="scan" onClick={onOpenModal} />


                  <Modal open={open} onClose={onCloseModal} center classNames={{
                    modal: "qr_scan_modal",
                  }}>
                    <QRCode className="scan_modal" value={`${website}register/${sponsorId}`} />
                  </Modal>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4 bitcoin-section">
                  <div className='quick-action-video'>
                    <div className='quick-action-video'>
                      <video
                        autoPlay
                        muted
                        loop
                        style={{
                          width: '100%',
                          height: '310px',
                          objectFit: 'cover',
                          borderRadius: '10px'
                        }}
                      >
                        <source src={tradeVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                  <div className="quick-actions">
                    <h3>Quick Actions</h3>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'><img src={usd} className="card-logo" alt="Covido logo" /></div>
                          <div className="action-des">

                            <h6 className="card-title">{t("Bot Status")}</h6>
                            <p style={{ color: active === 'Active' ? 'green' : 'red' }}>
                              {active}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'><img src={usd} className="card-logo" alt="Covido logo" /></div>
                          <div className="action-des">

                            <h6 className="card-title">{t("Trade Account")}</h6>
                            <p style={{ color: (tradefund?.trade_fund > 0 || tradefund?.compound_trade_fund > 0) ? 'green' : 'red' }}>
                              {(tradefund?.trade_fund > 0 || tradefund?.compound_trade_fund > 0) ? 'ON' : "OFF"}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={wallet} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Bot Direct Bonus")}</h6>
                            <p className="card-text">{allUserData?.directIncome >= "0" ? `$${Number(allUserData?.directIncome)?.toFixed(2)}` : '-'}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={money1} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Bot Rank Income")}</h6>
                            <p className="card-text">{allUserData?.rankIncome >= "0" ? `$${Number(allUserData?.rankIncome)?.toFixed(2)}` : '-'}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={salary} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Bot Rank Reward")}</h6>
                            <p className="card-text">{allUserData?.rankrewardsIncome >= "0" ? `$${Number(allUserData?.rankrewardsIncome)?.toFixed(2)}` : '-'}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={money2} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Deposit Bonus")}</h6>
                            <p className="card-text">{allUserData?.depositBonusIncome >= "0" ? `$${Number(allUserData?.depositBonusIncome)?.toFixed(2)}` : '-'}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={money2} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Compounding Deposit bonus ")}</h6>
                            <p className="card-text">{allUserData?.depositBonusIncome >= "0" ? `$${Number(info?.income_info?.deposit_compound_bonus_income)?.toFixed(2)}` : '-'}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={money3} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Trading Bonus")}</h6>
                            <p className="card-text">{allUserData?.profitSharingIncome >= 0 ? `$${Number(allUserData?.profitSharingIncome)?.toFixed(2)}` : '0.00'}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={money3} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Trading Compound Bonus")}</h6>
                            {/* <p className="card-text">{info?.income_info?.compound_trade_fund >= 0 ? `$${Number(info?.income_info?.compound_trade_fund)?.toFixed(2)}` : '$0'}</p> */}
                            <p className="card-text">$0</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={moneyImg} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Level Bonus")}</h6>
                            <p className="card-text">{allUserData?.levelIncome >= "0" ? `$${Number(allUserData?.levelIncome)?.toFixed(2)}` : '-'}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={money4} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("IB Bouns")}</h6>
                            <p className="card-text">{allUserData?.ibCommissionIncome >= 0 ? `$${Number(allUserData?.ibCommissionIncome)?.toFixed(2)}` : '0.00'}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="action-box">
                          <div className='card_img_outer'>
                            <img src={salary} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="action-des">
                            <h6 className="card-title">{t("Salary")}</h6>
                            <p className="card-text">{allUserData?.salaryIncome >= "0" ? `$${Number(allUserData?.salaryIncome)?.toFixed(2)}` : '-'}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Col lg={4} className="for-order">
                  <Card className="middle-card p-3 bg-dark text-white">
                    <div className="row">
                      <div className="col-sm-6">
                        <h6 className="text-muted">Trading Account Balance</h6>
                        <h2 className='wallet-value'>
                          <AccountBalanceWalletIcon /> ${Number(tradefund?.trade_fund)} <span className="text-muted">USD</span>
                        </h2>
                      </div>
                      <div className="col-sm-6">
                        <h6 className="text-muted">Compound Account Balance</h6>
                        <h2 className='wallet-value'>
                          {info?.income_info?.compound_trade_fund >= 0 ? `$${Number(info?.income_info?.compound_trade_fund)?.toFixed(2)}` : '$0'}

                        </h2>
                      </div>
                    </div>

                    <div className="col-12 ">
                      <div className="sponsor-card-container">
                        <p class="title-heading">Trade Profit </p>
                        <div className="sponsor-card profit-sponser-card">
                          <div >
                            <img src={income} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="sponsor-info">
                            <span className="label">{t("Total Trade Profit")} </span>
                            <span className="id">
                              <span className="id">{tradefund?.mt5_profit ? tradefund?.mt5_profit?.toFixed(2) : "$0"}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='dash-btns'>
                      <Link className='button_style' to="/buy-infra">Bot Activation</Link>
                      <Link className='button_style' to="/trade-transfer">Trade Deposit</Link>
                    </div>

                    <div className="row for-margin">

                      {/* // onne  */}
                      <div classNames="col-12 col-md-6 col-lg-12">
                        <div className='sponsor-card1'>
                          <div className='nw-spon'>
                            <div className='spon-heading'>
                              <p class="title-heading1"> MT5 ID</p>
                            </div>
                            <div className="sponsor-info">
                              <span className="id"> {allMt5UserData?.tradeXEntry?.mt5id}</span>
                            </div>
                          </div>
                          <div className="content-s">
                            <div className='spon-heading'>
                              <p class="title-heading1 mb-0"> MT5 Investor Password</p>
                            </div>
                            <div className="sponsor-info">
                              <span className="id"> {allMt5UserData?.tradeXEntry?.investpass}</span>
                            </div>
                          </div>
                          <div className='nw-spon nwe-mb'>
                            <div className='spon-heading'>
                              <p class="title-heading1"> MT5 Server</p>
                            </div>
                            <div className="sponsor-info">
                              <span className="id">DEZIRE CAPITAL MARKET LTD</span>
                            </div>
                          </div>
                          <div className='nw-spon'>
                            <div className='spon-heading'>
                              <p class="title-heading1"> Compound MT5 ID</p>
                            </div>
                            <div className="sponsor-info">
                              <span className="id"> {allMt5UserData?.tradeXCompoundEntry?.mt5id}</span>
                            </div>
                          </div>

                          <div className='nw-spon spon-flex'>
                            <div className="icon-container" >
                              <img src={mt5} className="card-logo" alt="Covido logo" />
                            </div>
                            <div className="content-s">
                              <div className='spon-heading'>
                                <p class="title-heading1"> Compound Investor Password</p>
                              </div>
                              <div className="sponsor-info">
                                <span className="id"> {allMt5UserData?.tradeXCompoundEntry?.investpass}</span>
                              </div>
                            </div>

                          </div>

                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-12">
                        <p class="title-heading"> BOT Rank</p>
                        <div className="sponsor-card">
                          <div className="icon-container" >
                            <img src={bot} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="sponsor-info">
                            <span className="label">Bot Rank</span>
                            <span className="id">R {allUserData?.userInfo?.user_info?.rank} </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-12">
                        <p class="title-heading">Level</p>
                        <div className="sponsor-card">
                          <div className="icon-container" >
                            <img src={mlm} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="sponsor-info">
                            <span className="label">Level Open</span>
                            <span className="id">L {allUserData?.userInfo?.user_info?.level_open} </span>
                          </div>
                        </div>

                      </div>
                      <div className="col-12 col-md-6 col-lg-12">
                        <p class="title-heading">IB Level</p>

                        <div className="sponsor-card">
                          <div className="icon-container" >
                            <img src={birefcase} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="sponsor-info">
                            <span className="label">Current Rank</span>
                            <span className="id">IB {allUserData?.userInfo?.user_info?.ib_rank}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-12">
                        <p class="title-heading">Salary Rank</p>
                        <div className="sponsor-card">
                          <div className="icon-container" >
                            <img src={salary} className="card-logo" alt="Covido logo" />
                          </div>
                          <div className="sponsor-info">
                            <span className="label">Rank</span>
                            <span className="id">SR {allUserData?.userInfo?.user_info?.salary_rank}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>

                </Col>
                <div className="col-lg-4 bitcoin-section bitcoin-sec1">
                  <div className="bitcoin-card">
                    <div className="bitcoin-h">
                      <div className="bitcoin-header">
                        <h3>XAU/USD <span></span></h3>
                        <h2>{price}</h2>
                      </div>
                    </div>

                    <div className="for-candlestick">
                      <CandleChart />
                    </div>
                    <div className="for-below-cards">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="left-card">
                            <div className="for-lef-box-graph">
                              <img src={graphi} alt="" className='graphi' />
                            </div>
                            <div class="comparison">
                              <div class="comparison-item">
                                <span class="dot orange"></span>
                                <div>
                                  <p>Total Business</p>
                                  <p>${teamBusiness?.toFixed(4)}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="left-card diff">
                            <div className="for-lef-box-graph">
                              <img src={graphi} alt="" className='graphi' />
                            </div>

                            <div class="comparison">
                              <div class="comparison-item">
                                <span class="dot orange"></span>
                                <div>
                                  <p>Total Earning</p>
                                  <p>{tradefund?.total_income ? (`$${Number(tradefund?.total_income + tradefund?.bot_total_income)?.toFixed(2)}`) : '0.00'}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="card-container">
                          <div class="info-card income">
                            <div class="icon">
                              <img src={arrowup} alt="" className='graph-img' />
                            </div>
                            <p>Total E-wallet</p>
                            <h2 className='upgrade-h'>{tradefund?.deposit_fund ? (`$${Number(tradefund?.deposit_fund)?.toFixed(2)}`) : '0.00'}</h2>
                          </div>

                          <div class="info-card expenses">
                            <div class="icon">
                              <img src={arrodown1} alt="" className='graph-img' />
                            </div>
                            <Link to="/capital-withdraw">Trading Fund Withdraw</Link>
                            <h2 className='downgrade-h'> {balance ? `$${Math.abs(Number(balance))}` : '0.00'}</h2>
                          </div>
                          <div class="info-card revenue ctm-revenueco">
                            <div class="icon">
                              <img src={arrowup1} alt="" className='graph-img' />
                            </div>
                            <p>KYC Status</p>
                            <h2 className='normal-h'></h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='loader_main'>
                {loading &&
                  <div className="spinner_bg">
                    <div className="color_ring">  <ColorRing
                      visible={true}
                      height="80"
                      width="80"

                      ariaLabel="blocks-loading"
                      wrapperStyle={{}}
                      wrapperClass="blocks-wrapper"
                      colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                    />
                    </div>
                  </div>
                }
                {newsData?.status &&
                  <div className="banner-section-top">
                    <div className='banner-news'>
                      <p> <VolumeUpRounded /></p>
                      <Marquee className='marquuqqq'>
                        <p><b>{t(newsData?.title)}: </b>{t(newsData?.description)}</p>
                      </Marquee>
                    </div>
                    <img src={light_banner1} className="banner-img" alt="Covido logo" />
                  </div>
                }

                {/* second section */}
                <div className='loader_main'>
                  {loading &&
                    <div className="spinner_bg">
                      <div className="color_ring">  <ColorRing
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="blocks-loading"
                        wrapperStyle={{}}
                        wrapperClass="blocks-wrapper"
                        colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                      />
                      </div>
                    </div>
                  }
                </div>

                {/* profit cards  */}
                <div className="profit_cards">
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <div className="card profit_inner_card card_4" >
                            <div className="card-body">
                              <div className="icon_profit">
                                <img src={profit4} className="profit" alt="Covido logo" />
                              </div>
                              <div className="card_data">
                                <h5 className="card-title card-t">{t("Profit")}</h5>
                                <p className="card-text card-tt">Currently</p>
                                <h6>${todayProfit?.toFixed(4)}</h6>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                          <div className="card profit_inner_card card_1" >
                            <div className="card-body">
                              <div className="icon_profit">
                                <img src={profit3} className="profit" alt="Covido logo" />
                              </div>
                              <div className="card_data">
                                <h5 className="card-title card-t">{t("Profit")}</h5>
                                <p className="card-text card-tt">{t("Current Month")}</p>
                                <h6>${currentMonthProfit?.toFixed(4)}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <div className="card profit_inner_card card_3" >
                            <div className="card-body">
                              <div className="icon_profit">
                                <img src={hour24} className="profit" alt="Covido logo" />
                              </div>
                              <div className="card_data">
                                <p className="card-text card-tt">Bot Available Income</p>
                                <h6>${tradefund?.bot_available_income?.toFixed(4)}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="card profit_inner_card card_2" >
                            <div className="card-body">
                              <div className="icon_profit">
                                <img src={profit5} className="profit" alt="Covido logo" />
                              </div>
                              <div className="card_data">
                                <p className="card-text card-tt">Trade Available Income</p>
                                <h6>${tradefund?.available_income?.toFixed(4)}</h6>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                          <div className="card profit_inner_card card_2" >
                            <div className="card-body">
                              <div className="icon_profit">
                                <img src={profit5} className="profit" alt="Covido logo" />
                              </div>
                              <div className="card_data">
                                <p className="card-text card-tt">Achieved Salary</p>
                                <h6>${allSalaryAcheived?.toFixed(2)}</h6>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                          <div className="card profit_inner_card card_2" >
                            <div className="card-body">
                              <div className="icon_profit">
                                <img src={profit5} className="profit" alt="Covido logo" />
                              </div>
                              <div className="card_data">
                                <h6>Team A : {legTeamData?.firstleg}</h6>
                                <h6>Team B : {legTeamData?.secondleg}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      </div>
                    </div>
                  </div>
                </div>

                {/* table section */}
                <div className="table_section">
                  <div className="scrolling_table">
                    <div className="scroll_under">
                      <Table className="support_table">
                        <thead>
                          <tr className="table_heading_row">
                            <th className="table_heading"> #</th>
                            <th className="table_heading"> {t("Amount")}</th>
                            <th className="table_heading"> {t("Type")}</th>
                            <th className="table_heading"> {t("Remark")}</th>
                            <th className="table_heading">{t("Date")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fundValues.length == 0 ? <tr className='table-body-tr'>
                            <td colSpan={4} style={{ textAlign: 'center' }}>{t("Data not found")}</td>
                          </tr> :
                            <>
                              {fundValues?.map((item, index) => {
                                return (
                                  <>
                                    <tr className="table_data_row">
                                      <td className="table_data">{page > 1 ? index + keyCount + 1 : index + 1}</td>
                                      <td className="table_data" style={{ color: item?.type === "credit" || item?.amount > 0 ? "green" : "red" }}>${Math.abs(item?.amount)?.toFixed(2)}</td>
                                      <td className="table_data">{item?.type?.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</td>
                                      <td className="table_data">{item?.remark}</td>
                                      <td className="table_data payment_fee">{dateformat(item?.created_at, "UTC:dd-mm-yyyy hh:mm:ss TT")}</td>
                                    </tr>
                                  </>
                                )
                              })}
                            </>}
                        </tbody>
                      </Table>
                      {totalRecords > 10 && <ReactPaginate className="pagination__2 " activeClassName="active"
                        breakLabel="..."
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={1}
                        pageCount={totalRecords / 10}
                        previousLabel="<"
                      />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {open3 && (
        <Modal open={open3} onClose={closeModal3} center
          classNames={{
            modal: "homepage_modal",
          }}>
          <div className="banner_modal">
            <img src={bannerData?.banner} alt={bannerData?.description} className='banner_img' />
            <h6 className='modal-heading'>{bannerData?.description}</h6>
          </div>
        </Modal>
      )}
    </>
  )
}

export default Dashboard;